// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';
import type { ScarcityType } from '../../../../../types/apolloType';

type Props = {
  scarcity: ScarcityType,
};

type State = {
  scalePenetration: Scale[],
  scalePeople: Scale[],
  scaleTurnover: Scale[],
};

type Scale = {
  note: number,
  range: string,
}

class ScarcityComponent extends React.Component<Props, State> {
  state = {
    scalePenetration: [
      { note: 10, range: '5%' },
      { note: 9, range: '10%' },
      { note: 8, range: '20%' },
      { note: 7, range: '30%' },
      { note: 6, range: '40%' },
      { note: 5, range: '50%' },
      { note: 4, range: '60%' },
      { note: 3, range: '70%' },
      { note: 2, range: '80%' },
      { note: 1, range: '100%' },
      { note: 0, range: '' }
    ],
    scalePeople: [
      { note: 10, range: '3' },
      { note: 9, range: '15' },
      { note: 8, range: '30' },
      { note: 7, range: '50' },
      { note: 6, range: '80' },
      { note: 5, range: '120' },
      { note: 4, range: '170' },
      { note: 3, range: '220' },
      { note: 2, range: '300' },
      { note: 1, range: '400' },
      { note: 0, range: '' }
    ],
    scaleTurnover: [
      { note: 10, range: '€30,00' },
      { note: 9, range: '€20,00' },
      { note: 8, range: '€10,00' },
      { note: 7, range: '€5,00' },
      { note: 6, range: '€3,00' },
      { note: 5, range: '€2,50' },
      { note: 4, range: '€1,25' },
      { note: 3, range: '€1,00' },
      { note: 2, range: '€0,75' },
      { note: 1, range: '€0,50' },
      { note: 0, range: '' }
    ],
  }

  render() {
    return (
      <div className="scarcity">
        <div className="scarcity-standard">
          <p className="scarcity-title">{I18n.t('attractiveScore.scarcity.penetration')}</p>
          {
            this.state.scalePenetration.map((penetration) => (
              <div className="scale-container">
                <div className={`note ${this.props.scarcity.storesInUrwNote === penetration.note ? ' active' : ''}`}>
                  {penetration.note}
                </div>
                { penetration.range !== '' && <div className="lign" /> }
                <span className="range">{penetration.range}</span>
              </div>
            ))
          }
        </div>

        <div className="scarcity-standard">
          <p className="scarcity-title">{I18n.t('attractiveScore.scarcity.people')}</p>
          {
            this.state.scalePeople.map((people) => (
              <div className="scale-container">
                <div className={`note ${this.props.scarcity.storesInFrNote === people.note ? ' active' : ''}`}>
                  {people.note}
                </div>
                { people.range !== '' && <div className="lign" /> }
                <span className="range">{people.range}</span>
              </div>
            ))
          }
        </div>

        <div className="scarcity-standard">
          <p className="scarcity-title">{I18n.t('attractiveScore.scarcity.turnover')}</p>
          {
            this.state.scaleTurnover.map((turnover) => (
              <div className="scale-container">
                <div className={`note ${this.props.scarcity.turnoverRetailerFrNote === turnover.note ? ' active' : ''}`}>
                  {turnover.note}
                </div>
                { turnover.range !== '' && <div className="lign" /> }
                <span className="range">{turnover.range}</span>
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

export default ScarcityComponent;
